// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.para-text {
  font-size: 18px;
}

.fillcountReadOffer {
  color: #3f3f3f;
}

#terms-and-limitationsText {
  border: none;
  background-color: inherit;
  text-decoration: underline;
  padding: 0;
  color: #004d96;
  font-size: 14px;
  font-weight: 600;
}

.about-Pharmacy-heading-prescription {
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
  color: #0d2b38;
}

.first-para {
  margin-top: 30px;
}

.para-text-prescription {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #4d4d4f;
}

.progress-bar {
  background: none !important;
  overflow: initial !important;
  height: 25px !important;
  position: relative;
  z-index: 1;
  top: 60px;
  flex-direction: row !important;
}
.progress-bar div {
  height: 15px;
  width: 100%;
}
.progress-bar .progress-bar-active {
  background-color: #ff5842;
}
.progress-bar .cracker-icon {
  z-index: 100;
  display: block;
  width: 40px;
  height: 40px;
  position: relative;
  top: -1px;
  left: -48px;
}
.progress-bar .reward-icon {
  z-index: 10;
  display: block;
  width: 50px;
  height: 50px;
  position: relative;
}
.progress-bar .green-flag {
  display: block;
  width: 30px;
  height: 30px;
  position: relative;
  top: -460%;
  left: 34%;
  z-index: -1;
}
.progress-bar .green-flag1 {
  display: block;
  position: relative;
  left: 60%;
  top: -610%;
}
.progress-bar .gift-icon1 {
  z-index: 10;
  display: block;
  width: 40px;
  height: 40px;
  position: relative;
  top: -155%;
  left: 60%;
}
.progress-bar .gift-icon2 {
  z-index: 10;
  display: block;
  width: 40px;
  height: 40px;
  position: relative;
  top: -170%;
  left: 30%;
}
.progress-bar .orange-flag {
  z-index: -10;
  display: block;
  width: 40px;
  height: 40px;
  position: relative;
  top: -630%;
  left: 22%;
}
.progress-bar .half-progress-bar-inactive {
  display: flex;
}
.progress-bar .half-progress1 {
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  width: 50%;
  background-color: #ff5842;
}
.progress-bar .half-progress2 {
  width: 50%;
  background-color: #c4c4c4;
}
.progress-bar .progress-bar-inactive {
  background-color: #c4c4c4;
}
.progress-bar .progress-bar-curveactive {
  border-top-left-radius: 25px;
  border-bottom-left-radius: 25px;
  background-color: #ff5842;
}

.progressContainer {
  background-color: #f9fbfb;
  border-radius: 10px;
  position: relative;
  height: 140px;
  overflow: hidden;
}

.success-checkmark {
  display: block;
  z-index: 100;
  color: #915600;
  font-size: 17px;
  width: 30px;
  height: 30px;
  text-align: center;
  position: relative;
  top: -128%;
  left: 58%;
}

.empty-checkmark {
  display: block;
  z-index: 100;
  color: #915600;
  font-size: 17px;
  width: 25px;
  height: 25px;
  text-align: center;
  position: relative;
  top: -128%;
  left: 58%;
}

#success_0 {
  left: 60%;
}

@media (max-width: 480px) {
  .green-flag {
    left: 13% !important;
  }
  .orange-flag {
    left: 14% !important;
  }
}
@media (min-width: 481px) and (max-width: 767px) {
  .green-flag {
    left: 20% !important;
  }
  .orange-flag {
    left: 12% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/PrescriptionFillsCount/PrescriptionFillsCount.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;;AACA;EACE,cAAA;AAEF;;AAAA;EACE,YAAA;EACA,yBAAA;EACA,0BAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAGF;;AADA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAIF;;AAFA;EACE,gBAAA;AAKF;;AAHA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAMF;;AAHA;EACE,2BAAA;EACA,4BAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,8BAAA;AAMF;AALE;EACE,YAAA;EACA,WAAA;AAOJ;AALE;EACE,yBAAA;AAOJ;AAJE;EACE,YAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AAMJ;AAJE;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAMJ;AAJE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;AAMJ;AAJE;EACE,cAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AAMJ;AAJE;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;AAMJ;AAJE;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;AAMJ;AAJE;EACE,YAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;AAMJ;AAJE;EACE,aAAA;AAMJ;AAJE;EACE,4BAAA;EACA,+BAAA;EACA,UAAA;EACA,yBAAA;AAMJ;AAJE;EACE,UAAA;EACA,yBAAA;AAMJ;AAHE;EACE,yBAAA;AAKJ;AAHE;EACE,4BAAA;EACA,+BAAA;EACA,yBAAA;AAKJ;;AAFA;EACE,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;AAKF;;AAFA;EACE,cAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;AAKF;;AAHA;EACE,cAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;AAMF;;AAHA;EACE,SAAA;AAMF;;AAHA;EACE;IACE,oBAAA;EAMF;EAJA;IACE,oBAAA;EAMF;AACF;AAHA;EACE;IACE,oBAAA;EAKF;EAHA;IACE,oBAAA;EAKF;AACF","sourcesContent":[".para-text {\n  font-size: 18px;\n}\n.fillcountReadOffer {\n  color: #3f3f3f;\n}\n#terms-and-limitationsText {\n  border: none;\n  background-color: inherit;\n  text-decoration: underline;\n  padding: 0;\n  color: #004d96;\n  font-size: 14px;\n  font-weight: 600;\n}\n.about-Pharmacy-heading-prescription {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 28px;\n  color: #0d2b38;\n}\n.first-para {\n  margin-top: 30px;\n}\n.para-text-prescription {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n  color: #4d4d4f;\n}\n\n.progress-bar {\n  background: none !important;\n  overflow: initial !important;\n  height: 25px !important;\n  position: relative;\n  z-index: 1;\n  top: 60px;\n  flex-direction: row !important;\n  div {\n    height: 15px;\n    width: 100%;\n  }\n  .progress-bar-active {\n    background-color: #ff5842;\n  }\n\n  .cracker-icon {\n    z-index: 100;\n    display: block;\n    width: 40px;\n    height: 40px;\n    position: relative;\n    top: -1px;\n    left: -48px;\n  }\n  .reward-icon {\n    z-index: 10;\n    display: block;\n    width: 50px;\n    height: 50px;\n    position: relative;\n  }\n  .green-flag {\n    display: block;\n    width: 30px;\n    height: 30px;\n    position: relative;\n    top: -460%;\n    left: 34%;\n    z-index: -1;\n  }\n  .green-flag1 {\n    display: block;\n    position: relative;\n    left: 60%;\n    top: -610%;\n  }\n  .gift-icon1 {\n    z-index: 10;\n    display: block;\n    width: 40px;\n    height: 40px;\n    position: relative;\n    top: -155%;\n    left: 60%;\n  }\n  .gift-icon2 {\n    z-index: 10;\n    display: block;\n    width: 40px;\n    height: 40px;\n    position: relative;\n    top: -170%;\n    left: 30%;\n  }\n  .orange-flag {\n    z-index: -10;\n    display: block;\n    width: 40px;\n    height: 40px;\n    position: relative;\n    top: -630%;\n    left: 22%;\n  }\n  .half-progress-bar-inactive {\n    display: flex;\n  }\n  .half-progress1 {\n    border-top-left-radius: 15px;\n    border-bottom-left-radius: 15px;\n    width: 50%;\n    background-color: #ff5842;\n  }\n  .half-progress2 {\n    width: 50%;\n    background-color: #c4c4c4;\n  }\n\n  .progress-bar-inactive {\n    background-color: #c4c4c4;\n  }\n  .progress-bar-curveactive {\n    border-top-left-radius: 25px;\n    border-bottom-left-radius: 25px;\n    background-color: #ff5842;\n  }\n}\n.progressContainer {\n  background-color: #f9fbfb;\n  border-radius: 10px;\n  position: relative;\n  height: 140px;\n  overflow: hidden;\n}\n\n.success-checkmark {\n  display: block;\n  z-index: 100;\n  color: #915600;\n  font-size: 17px;\n  width: 30px;\n  height: 30px;\n  text-align: center;\n  position: relative;\n  top: -128%;\n  left: 58%;\n}\n.empty-checkmark {\n  display: block;\n  z-index: 100;\n  color: #915600;\n  font-size: 17px;\n  width: 25px;\n  height: 25px;\n  text-align: center;\n  position: relative;\n  top: -128%;\n  left: 58%;\n}\n\n#success_0 {\n  left: 60%;\n}\n\n@media (max-width: 480px) {\n  .green-flag {\n    left: 13% !important;\n  }\n  .orange-flag {\n    left: 14% !important;\n  }\n}\n\n@media (min-width: 481px) and (max-width: 767px) {\n  .green-flag {\n    left: 20% !important;\n  }\n  .orange-flag {\n    left: 12% !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
